export interface Lang {
  [key: string]: string;
}

const en: Lang = {
  headersLogoAria: 'Go to home page',
  requiredText: 'This field is required',
  invalidEmailText: 'Please enter valid e-mail address',
  invalidPhoneText: 'Please enter valid phone number',
  nameCannotBeEmailText: 'Event name cannot be an email',
  nameCannotBeLinkText: 'Event name cannot be a link',
  passwordMinLenghtText: 'Password must have at least 8 characters',
  passwordNotMatchingText: 'Password and confirm password does not match',
  invalidCredentialsText: 'Invalid email or password',
  passwordFormatText:
    'Password must contain lower, upper case and numeric character',
  insights: 'Insights',
  totalInsights: 'Employees on tested.me',
  insightsDescription: 'View information about people in your Building.',
  flaggedModalDescription:
    'These employees were flagged because they have submitted health test results that indicate they may not be well. You may want to investigate further',
  approvedEntry: 'Approved entry',
  statusUnknown: 'Status unknown',
  flagged: 'Flagged',
  healthReview: 'Health review required (Employees)',
  onsiteEmployees: 'Number of employees on site today',
  offsiteEmployees: 'Employees not on site today',
  accept: 'Accept',
  copyRightText: '© 2020 Tested.me',
  copyRightLink: 'a Me Company',
  yes: 'Yes',
  no: 'No',
  ok: 'OK',
  on: 'on',
  readMore: 'Read more',
  logOut: 'Log out',
  qr: 'QR code',
  blog: 'Blog',
  ourBlog: 'Our blog',
  getStarted: 'Get Started',
  aboutMe: 'About Me Project',
  hiw: 'How it works',
  forIndividuals: 'For individuals',
  forBusiness: 'For business',
  joinWaitList: 'Join waitlist',
  firstNamePlaceholder: 'Enter first name',
  lastNamePlaceholder: 'Enter last name',
  joinWaitListHeading: 'Sign up to hear the latest on our launch',
  step1: 'Step 1',
  step2: 'Step 2',
  step3: 'Step 3',
  step4: 'Step 4',
  step5: 'Step 5',
  faq: 'FAQs',
  learnMore: ' Learn more',
  contact: 'Contact',
  privacyPolicy: 'Privacy policy',
  termsAndConditions: 'Terms & Conditions',
  acceptableUsePolicy: 'Acceptable Use Policy',
  websiteTermsOfUse: 'Website Terms Of Use',
  linkedIn: 'LinkedIn',
  twitter: 'Twitter',
  facebook: 'Facebook',
  medium: 'Medium',
  interestForm: 'Interest Form',
  instagram: 'Instagram',
  companyName: 'Company name',
  enterCompanyName: 'Enter company name',
  emailExist:
    'This email already exists. Please try to log in or try again with a different email.',
  humanizedDateAgo: 'ago',
  humanizedDateToday: 'today',
  temperatureUnitCelsius: '°C',
  temperatureUnitFahrenheit: '°F',

  signinText: 'Sign in',
  forgotPasswordText: 'Forgot password',
  bannerHead: `Register your customers quickly and easily with a solution unique to your venue`,
  createAccountText: 'Create account',
  moreInfo: 'Get more information',
  mainBannerHeading1: 'Your digital',
  mainBannerHeading2: 'health partner',
  mobileBannerHeading: 'Your digital health partner',
  bannerParagraph:
    "Using a health verification symbol that's as unique as you are, tested.me is already helping thousands of people enjoy a better quality of life.",
  subBannerContent: 'Enable your customers to sign in safely and responsibly',
  businessUsual:
    'The safer way to return to work and get back to ‘business as usual’',
  meetBusinessHeading: 'Meet tested.me for business',
  meetBusinessHeading1: 'Fulfil duty of care with clearer employee health data',
  meetBusinessDes1:
    'Being a responsible employer has never been more important. With tested.me, you can view your team’s live health data whenever you need to.',

  businessBannerHeading1: 'Be a leader',
  businessBannerHeading2: 'in social',
  businessBannerHeading3: 'responsibility',
  businessBannerDes:
    'Drive positive change for your customers and employees with tested.me, a digital health verification tool for your business',
  businessBannerDes2: 'Get your free ',
  businessBannerLink: 'Visitor Registration Solution',
  businessBannerDes3: ', today',
  partnerHeading: 'What our business partners say',

  missionContent:
    'Our mission is to help you share your health data more easily and securely.',
  downloadApp:
    'Download the free tested.me app on the App Store or Google Play',
  verifyApp: 'Verify your identity and receive your unique Me ID symbol',
  healthStatus:
    'Update your health status including any Covid-19 test results & body temperature',
  displayStatus:
    'Display your health status to show you are safe to work, travel and play',
  trustContent:
    'Your trust is as important to us as your health and happiness is to you.',

  communityHeading: 'What our community says',
  communityMemberName1: 'Tom Stewart',
  communityMemberRole1: 'Sales Partner',
  communitiesMemberDetail1:
    "'It's a sombre thought that our social and work behaviours won't be the same again for a long time, but tested.me gives organisations and individuals a level of confidence and support that is currently absent during this pandemic and beyond.'",
  communityMemberName2: 'Paul Sweeney',
  communityMemberRole2: 'MD Black Pear Electrical',
  communitiesMemberDetail2:
    "'Having had to close our business for 10 weeks, tested.me gives us the confidence to re-open. During these concerning times it's essential that as business owners we do everything reasonably practical to protect our team and customers from Covid-19'",
  communityMemberName3: 'Brendan Murphy',
  communityMemberRole3: 'Co-Founder',
  communityMemberRole4: 'of BARBIE Bristol',
  communitiesMemberDetail3:
    "'There are a huge number of Government restrictions for venue owners to adhere to and tested.me's contactless solution has been taken up by over 200 of our venues already. Hats off to tested.me for their speed of delivery!'",

  communityMemberName4: 'Rebecca Osman',
  communityMemberRole5: 'Roo’s Beach',
  communitiesMemberDetail5:
    "'Using tested.me ensures peace of mind for our staff while offering track and trace for our visitors. The simplicity of scanning in and out of the premises, plus keeping a tally on people’s health has become an effortless daily routine and has made people feel safer'",

  benefitsHeadText: 'Benefits',
  tileHeadingOne: 'Be responsible',
  tileHeadingTwo: 'Be in control',
  tileHeadingThree: 'Be safe',
  tileDesOne: 'Comply with the latest Government guidance',
  tileDesTwo: 'View data about your employees and their health status',
  tileDesThree: 'See who’s been refused entry to your building and why',

  createAccountBackText: 'Back',
  createAccountHeading: 'Join tested.me',
  createAccountPersonalDetails: 'Personal details',
  createAccountLabelName: 'First name',
  createAccountLastName: 'Last name',
  createAccountLabelPhone: 'Phone',
  createAccountCountry: 'Country',
  createAccountCountryEmptyValue: 'Choose country...',
  createAccountCompany: 'Venue Name',
  createAccountBusinessName: 'Business/Organisation name',
  createAccountIndustry: 'Industry',
  createAccountIndustryEmptyValue: 'Choose industry...',
  createAccountContactDetails: 'Venue address',
  createAccountBusinessAddress: 'Business/Organisation address',
  createAccountAddress1: 'Address line 1',
  createAccountAddress2: 'Address line 2',
  createAccountPostcode: 'Postcode',
  createAccountCity: 'City',
  createAccountSignInDetails: 'Sign in details',
  createAccountEmail: 'E-mail',
  createAccountPassword: 'Password',
  createAccountConfirmPassword: 'Confirm password',
  createAccountGroupOrChain: 'Are you part of a group/chain?',
  createAccountGroupOrChainDropdown: 'Group/Chain',
  createAccountGroupOrChainOther: 'Other',
  createAccountGroupOrChainPlaceholder: 'Choose group/chain',
  createAccountButton: 'Create account',
  createAccountPolicyContent:
    'By submitting this form, you agree to the Privacy Policy of our website.',

  createCompanyAccountBackText: 'Back',
  createCompanyLiteAccountHeading:
    'Get started with our Visitor Registration Solution',
  createCompanyLiteAccountSubheading:
    'Create your account to get your business’s free unique QR code and visitor registration dashboard. No card details required.',
  createCompanyProAccountHeading:
    'Start your free Health Verification Solution trial',
  createCompanyProAccountSubheading:
    'Create your account to gain access to your business’s full health verification dashboard. Your free trial will last 14 days. Cancel any time.',
  createCompanyEnterpriseAccountHeading:
    'Buy one of our plans for your business ',
  createCompanyEnterpriseAccountSubheading:
    'To buy this plan you have to create the account, please fill the details below',
  createCompanyAccountPaymentDetails: 'Payment details',
  createCompanyAccountPlan: 'Plan',
  createCompanyAccountPlanEmptyValue: 'Choose plan...',
  createCompanyAccountCreditCard: 'Card number',
  createCompanyAccountPersonalDetails: 'Company details',
  createCompanyAccountCompanyName: 'Company name',
  addVatNumber: 'VAT/GST number',
  createCompanyAccountIndustry: 'Industry',
  createCompanyAccountIndustryEmptyValue: 'Choose industry...',
  createCompanyAccountCompanyEmail: 'Company email',
  createCompanyAccountCountry: 'Country',
  createCompanyAccountCountryEmptyValue: 'Choose country...',
  createCompanyAccountTimezoneEmptyValue: 'Choose timezone...',
  createCompanyAccountContactDetails: 'Company contact details',
  createCompanyAccountAddress1: 'Address line 1',
  createCompanyAccountAddress2: 'Address line 2',
  createCompanyAccountPostcode: 'Postcode',
  createCompanyAccountCity: 'City',
  createCompanyAccountTimezone: 'Timezone',
  createCompanyAccountSignInDetails: 'Account details',
  createCompanyAccountEmail: 'Email',
  createCompanyAccountPhone: 'Phone',
  createCompanyAccountPassword: 'Password',
  createCompanyAccountConfirmPassword: 'Confirm password',
  createCompanyAccountGroupOrChain: 'Are you part of a group/chain?',
  createCompanyAccountGroupOrChainDropdown: 'Group/Chain',
  createCompanyAccountGroupOrChainPlaceholder: 'Choose group/chain',
  createCompanyAccountSummaryPlan: 'Type of plan:',
  createCompanyAccountSummarySites: 'Number of sites:',
  createCompanyAccountSummarySitePrice: 'Price per site:',
  createCompanyAccountSummaryEmployees: 'Price per employee:',
  createCompanyAccountVatText: 'VAT/GST:',
  createCompanyAccountSummaryCost: 'Cost:',
  createCompanyAccountSummaryPrice: 'Total cost:',
  createCompanyAccountSummaryPricePerMonth: '/month',
  createCompanyAccountSummaryPricePerYear: '/year',
  createCompanyAccountSummaryPromoCode: 'Promo code',
  createCompanyAccountSummaryPromoCodePlaceholder: 'Enter here',
  createCompanyAccountAgreementText: 'I agree to',
  createCompanyAccountAgreementPrivacy: 'Privacy Policy',
  createCompanyAccountAgreementAnd: '&',
  createCompanyAccountAgreementTerms: 'Terms and Conditions',
  createCompanyAccountButton: 'Create account',
  createCompanyAccountAndBuyButton: 'Create account & buy',
  createCompanyAccountPolicyContent:
    'By submitting this form, you agree to the Privacy Policy of our website.',
  completeRegistrationPolicyContent:
    'By clicking “Complete registration”, you agree to our',
  completeRegistrationPolicyContentNext: 'and',
  visitorFormHeading: 'Please fill the details about you',
  visitorFormDescription:
    'Please fill in your details to get access to the venue.',
  visitorFormSubmit: 'Confirm and send',

  loginEmailContent: 'Email',
  loginEmailPlaceholder: 'Enter email',
  loginPasswordContent: 'Password',
  loginPasswordPlaceholder: 'Enter password',
  loginForgotContent: 'Forgot password?',

  dataShowHeading1: 'Data shows 81%',
  dataShowHeading2:
    'of adults expect Coronavirus to disrupt their lives for longer than six months.',
  sourceDate: '(Ipsos Mori)',
  lifeHeading: 'Our life has changed',
  lifeDescription:
    'Society may be slowly starting to remerge and rebuild, but many of us still feel unsafe outside of our homes. We remain worried about the impact of Coronavirus on our lives, especially our freedom, independence and ability to make plans. At tested.me, we believe in restarting our economy and helping each of us to feel more confident in our communities.',
  agreementContent:
    'Tick here if you agree for this venue, its alliance and tested.me to send you marketing materials in the future.',
  noteMessage:
    'To comply with Government Guidance during the Covid-19 pandemic, we are collecting your name and contact details. We will store these for 21 days only before deleting them in line with GDPR regulations. Your details will not be shared with any other company or organisation.',
  greenBannerHeadng:
    'Our mission is to get people back to work and their social lives, safely and responsibly',
  MeetTestedHeading: 'Meet tested.me',
  scanCodeSectionHeading: 'Claim your Me symbol',
  scanCodeSectionHeading2: '— it’s as unique',
  scanCodeSectionHeading3: 'as you are',
  scanCodeDescription: 'The Me symbol is the world’s first',
  scanCodeDescription2: 'algorithm-driven identity symbol. Use yours',
  scanCodeDescription3: 'to show you’re healthy to return to your work,',
  scanCodeDescription4: 'your community and the things you love.',
  healthProfileHeading: 'Set up your health profile in seconds',
  healthProfileDescription:
    'Your time matters. We’ve made it as simple as possible to share your choice of health data whenever you want to.',
  expHeading: 'Own your experience with smarter data controls',
  expDescription:
    'Everything we do has data security at its core and it’s only ever one swipe to wipe all your data. Your trust is as important to us as your health and happiness is to you.',

  verificationHeading: 'Your verification is almost done!',
  verificationDescription:
    'To complete it please click the link in the text message we’ve just sent to your phone number',
  verifiedHeading:
    'Thank you for confirming your contact details. Enjoy your visit!',

  footerAddress: '11 Green Street, London',
  hippaComplianceAria: 'HIPPA Verified',

  unknownError: 'Something went wrong :/',
  paymentFailedMessage: 'Payment failed, please try again',

  visitorHeading: 'The London Palladium',
  visitorSubHeading: 'View information about visitors in your Building',
  visitorCounter: '105',
  visitorSuccessText: 'Your verification went successfully!',
  visitorConfirmText:
    'Thank you for confirming your contact details. Enjoy your visit!',
  visitorsCheckedToday: 'Visitors checked in today',
  visitorsToday: 'stats counter section added',
  dashboardFilterText: '7th May 2020',
  resetPageLink: 'Reset Password',
  submitText: 'Submit',
  apiRequestFailed:
    'File uploaded successfully, But invite Api request failed!',
  forgotPasswordSuccess: 'We have e-mailed your password reset link!',
  resetPwdLink: 'Send reset password link',
  signupLink: 'Sign up',
  forgotPwdDescription:
    'Type your email below and we will send you a link to reset your password.',
  resetLinkSent: 'A reset link has been sent to you!',
  checkInboxText: 'Please check your inbox',
  doNotHaveAccount: `Don't have an account?`,

  resetPasswordText: 'New password',
  resetConfirmPasswordContent: 'Repeat password',
  resetPasswordContent: 'Password',
  resetPasswordPlaceholder: 'Enter password',
  repeatPasswordPlaceholder: 'Repeat password',
  resetSubmitText: 'Set new password',
  resetSuccessMsg: 'User password updated successfully.',
  downloadCsv: 'Download CSV',
  cookieHeading: 'COOKIE POLICY',
  cookieCloseAria: 'Close',
  cookieDescription:
    'Our website uses cookies to distinguish you from other employees of our website. This helps us to provide you with a good experience when you browse our website and also allows us to improve our site. By using our site you agree to our use of cookies.',
  cookiePolicyParagraph:
    'Our website uses cookies to distinguish you from other employees of our website. This helps us to provide you with a good experience when you browse our website and also allows us to improve our site.',
  cookiePolicyParagraph2:
    'A cookie is a small file of letters and numbers that we store on your browser or the hard drive of your computer if you agree. Cookies contain information that is transferred to your computer"s hard drive.',
  cookiePolicyParagraph3: 'We use the following cookies:',
  cookieSubHeading1: 'Strictly necessary cookies.',
  cookiePolicyParagraph4:
    'These are cookies that are required for the operation of our website. They include, for example, cookies that enable you to log into secure areas of our website, use a shopping cart or make use of e-billing services.',
  cookieSubHeading2: 'Analytical or performance cookies.',
  cookiePolicyParagraph5:
    'These allow us to recognise and count the number of visitors and to see how visitors move around our website when they are using it. This helps us to improve the way our website works, for example, by ensuring that employees are finding what they are looking for easily.',
  cookieSubHeading3: 'Functionality cookies.',
  cookiePolicyParagraph6:
    'These are used to recognise you when you return to our website. This enables us to personalise our content for you, greet you by name and remember your preferences (for example, your choice of language or region).',
  cookieSubHeading4: 'Targeting cookies.',
  cookiePolicyParagraph7:
    'These cookies record your visit to our website, the pages you have visited and the links you have followed. We will use this information to make our website and the advertising displayed on it more relevant to your interests. [We may also share this information with third parties for this purpose.]',
  cookiePolicyParagraph8:
    'You can block cookies by activating the setting on your browser that allows you to refuse the setting of all or some cookies. However, if you use your browser settings to block all cookies (including essential cookies) you may not be able to access all or parts of our website.',
  friendlyDatePlaceholder: 'D MMM YYYY',
  chooseDatePlaceholder: 'Choose date',
  datePlaceholder: 'DD/MM/YY',
  dateFrom: 'From',
  dateTo: 'To',
  qrCodePageH5: 'Please read this in case of issues.',
  qrCodePageLine1:
    'If you are an Android user and are having issues scanning this symbol,',
  qrCodePageLine2: 'you may need to do one of the following:',
  qrCodePageLine3: 'Download a QR reader from Google Play',
  qrCodePageLine4: 'Enable QR scanning in your settings',
  qrCodePageLine5:
    'Type in the following address into your browser and register your visit this way:',
  qrCodeImageAlt: 'QR code image',
  employeesDescription: 'View information about employees in your building',
  employeesCheckedInToday: 'Employees checked in today',
  employeesInBuilding: 'Employees in building',
  flaggedEmployees: 'Flagged Employees',
  employeesTotalNumber: 'Total number of employees',
  employeesWorkingRemotely: 'Employees working remotely',
  employeesWellBeing: 'Reported their well-being',
  employeesHQLabel: '(HQ)',
  visitorsCheckedInToday: 'Visitors checked in today',
  visitorsInBuilding: 'Visitors in building',
  flaggedVisitors: 'Flagged Visitors',
  visitorTotalNumber: 'Total number of visitors',
  usersManagement: 'Users Management',
  eventsManagement: 'Events Management',
  eventsManagementEvents: 'Events',
  eventsManagementAttendees: 'Attendees',
  usersManagementVisitors: 'Visitors',
  usersManagementEmployees: 'Employees',
  uploadCSV: 'Upload CSV',
  inviteUserButton: 'Add employee',
  inviteUserHeading: 'Invite to this organization',
  inviteEmailPlaceholder: 'Invite via email',
  inviteSubmitText: 'Send',
  waitListAgreement:
    'I agree to allow tested.me to contact me with marketing materials in the future',
  waitListSuccessMsg:
    "Thanks for joining the waitlist! We'll be in contact soon.",
  inviteEmployeeSuccessMessage: 'Employee invited successfully',
  navSettingsText: 'Settings',
  companyDetailsText: 'Company details',
  companyLocationsText: 'Locations',
  yourCompanyText: 'Your company',
  yourCompanyDetails: 'Details',
  userDataExport: 'User data export',
  employeeCheck: 'Employee check',
  billingText: 'Billing',
  accountSettingText: 'Account settings',
  moreBlog: 'See more blog posts',
  blogHeading: 'Title should go here',
  blogDate: '20.05.2020',
  employeeCheckText: 'Remind your employees to report their well-being',
  employeeCheckTextIsNotificationTurnedOff:
    'Remind your employees to report their well-being and temperature',
  employeeCheckSwitchText: 'Well-being check',
  blogDescription:
    'Few first sentences from the article. Validate your COVID-19 test results and current health status. Four 5 would be enough',
  companyNameText: 'Company name',
  companyAddressText: 'Company address',
  seeMoreDetailsText: 'See more details',
  noRecordFoundText: 'No records found.',
  noRecordFoundMatchingText: 'No records found matching criteria.',
  noDataFoundText: 'No data found',
  noDataSubmittedText:
    'It seems the user has not yet submitted any health data.',
  billingHistoryText: 'Billing history',
  addEmployeeText: '+ Add employee',
  addLocation: '+ Add Location',
  managerLabel: 'Manager',
  emailLabel: 'Email',
  phoneLabel: 'Phone',
  postCodeLabel: 'Post code',
  addressLabel: 'Address',
  cityLabel: 'City',
  countryLabel: 'Country',
  vatGstLabel: 'VAT/GST number',
  timezoneLabel: 'Timezone',
  workingHoursLabel: 'Working hours',
  buildingCapacityLabel: 'Building capacity',
  showMoreText: 'More...',
  lessText: 'Less',

  deleteText: 'Delete',
  editText: 'Edit',
  saveText: 'Save',
  cancelText: 'Cancel',
  removeText: 'Remove',
  previewText: 'Preview',

  planTypeText: 'Your plan type',
  usersText: 'users',
  perMonth: 'per month',
  perYear: 'per year',
  nextText: 'Next:',

  accountSettingsExportDataHeading: 'User data export',
  accountSettingsExportDataDetails: 'Learn more about user data export in our',
  accountSettingsExportDataKnowledgeBaseLink: 'knowledge base',
  accountSettingsExportDataText: 'Export data',
  accountSettingsChangePasswordHeading: 'Do you want to change your password ?',
  accountSettingsSendResetLinkText: 'Send reset link',
  accountSettingsLogoutHeadingText: 'Do you want to logout ?',
  accountSettingsDeleteAccountText: 'Would you like to delete your account ?',
  accountSettingsConfirmDeleteAccountText: 'Yes, I want to delete my account ',
  accountSettingsChangePassword: 'Change your password',

  exportDataModalInfoHeader: 'User data export',
  exportDataModalInfoMessage:
    'Due to data protection laws we limit the ability to export data at will. The user data export feature should only be used in case you’ve been asked to provide user data by government officials. This is not an automated process and will need to be verified by our staff.',
  exportDataModalFormMessage: 'Please fill out the form below.',
  exportDataModalLocation: 'Location',
  exportDataModalLocationPlaceholder: 'Choose location',
  exportDataModalUserType: 'User type',
  exportDataModalUserTypePlaceholder: 'Choose user type',
  exportDataModalUserTypeEmployees: 'Employees',
  exportDataModalUserTypeVisitors: 'Visitors',
  exportDataModalAgreement: 'I understand and wish to export user data',
  exportDataModalVisitorsInfo:
    'Due to data protection laws we are only permitted to store and deliver Visitor data from the last 3 weeks.',
  exportDataModalConfirmationMessage:
    'Thank you for submitting your request. Our staff will now review your request and contact you shortly by email.',
  exportDataModalContinueButton: 'Continue',
  exportDataModalConfirmButton: 'Confirm',
  exportDataModalOkButton: 'OK',

  changePaymentCardText: 'Change the payment card',
  addPaymentCardText: 'Add payment card',
  seeOtherPlansText: 'See others plans',
  upgradeYourPlanText: 'Upgrade your plan',
  upgradeLitePlanContentText: 'To add employees you have to upgrade from the ',
  upgradeProPlanContentText: 'To add locations you have to upgrade from the ',
  upgradeEnterprisePlanContentText:
    'To manage events you have to upgrade from the ',
  planText: ' plan',
  noThanksText: 'No, thank you',
  buttonChooseText: 'Choose',
  fromText: 'From',
  addCardText: 'Add credit or debit card',
  cardNoText: 'Card number',
  cardAddressText: 'Address',
  cardAddressPHold: 'Street',
  cardCityText: 'City',
  cardZipText: 'Zip Code',
  cardCountryText: 'Country',
  addCardButtonText: 'Use this card',
  addCardCancelButtonText: 'Cancel',
  confirmPlanHeadingStartText: 'Are you sure you want to change',
  confirmPlanHeadingMiddleText: 'plan to',
  confirmPlanHeadingEndText: 'plan?',
  confirmPlanText: 'The price and all settings of your plan will change',
  confirmSuccessPlanHeadingStartText: 'You’ve chosen',
  confirmSuccessPlanHeadingEndText: 'Plan',
  confirmSuccessPlanText: 'Remember you can always upgrade your plan',
  confirmSuccessButtonOk: 'OK',
  editEmployeeContactNoText: 'Contact number',
  editEmployeeEmailText: 'Email address',
  removeEmployeeHeadingText: 'Remove employee',
  editCompanyEditButton: 'Edit',
  seeInvoiceText: 'See invoice',
  invoiceText: 'Invoice',
  pricing: 'Pricing',
  pricingFromText: 'FROM',
  upgradePlanText: 'Upgrade plan',
  pricingPlanHeading: `Choose the plan that's the best for your business`,
  pricingPlanSubHeading: `Pay monthly, 12 month rolling contract with 30 day cancellation period`,
  pricingCustomerText: 'Visitor',
  pricingRegistrationSolution: 'Registration Solution',
  pricingHealthText: 'Health',
  pricingFree: 'Free',
  pricingEnterpriseHealth: 'Enterprise Health',
  pricingEventsText: 'Events',
  pricingWorkplaceText: 'Workplace',
  pricingVerificationSolution: 'Solution',
  pricingStripText:
    'For independent businesses e.g. pubs, restaurants, beauty salons and sports clubs',
  pricingStripText2: 'Suitable for all businesses from SME to Enterprise',
  pricingStripText3: 'For Events, Festivals, Sports and more',
  pricingEducationNonProfitNote:
    'Education / Not for profits please see note below.',
  pricingTextPOA: 'POA',
  pricingListingSubHeading1: 'TOP FEATURES:',
  pricingListingSubHeading2:
    'All features of Customers Registration Solutions PLUS:',
  pricingListingSubHeading3: 'TOP FEATURES:',
  pricingFeatureList1Line1: 'Unique QR symbol for your business',
  pricingFeatureList1Line2: 'Digitally capture visitor information in seconds',
  pricingFeatureList1Line3:
    'Fully ICO and GDPR complaint - we are not collecting data to sell for marketing purposes',
  pricingFeatureList1Line4:
    'Gain a secure digital audit trail and helps keep your visitors safe in the event of Track and Trace',
  pricingFeatureList1Line5:
    'Completely free with no hidden costs, helping independent and not for profit businesses',
  pricingFeatureList1Line6: 'Upgrade at any time if you need to',
  pricingFeatureList2Line1:
    'Protect yourself and your employees with a shared health status platform',
  pricingFeatureList2Line2:
    'Scan In/Out functionality providing frictionless entry for your staff and visitors',
  pricingFeatureList2Line3:
    'Combat the challenges of a newly distributed workforce, with full reporting and visibility of your staff and operations',
  pricingFeatureList2Line4:
    'Protect your staff and premises with affordable plans',
  pricingFeatureList2Line5:
    'Multiple site locations as standard and 5 employee licenses included (from £3.95 for additional employees)',
  pricingFeatureList2Line6: 'Ability to integrate with thermal scanning',
  pricingFeatureList2Line7: 'Multi level admin permissions',

  pricingFeatureList3Line1: 'Reduce risk of an outbreak at your event',
  pricingFeatureList3Line2:
    'Customisable and flexible - set your requirements of entry',
  pricingFeatureList3Line3:
    'Scaleable, easy to use platform to ensure everyone on the premises meets the requirements of entry',
  pricingFeatureList3Line4:
    'No need to manage sensitive health data - the platform does that for you',
  pricingFeatureList3Line5: 'Compliant and Secure',
  pricingFeatureList3Line6:
    'Know at a glance how many people are on your premises',
  pricingFeatureList3Line7:
    'Integrate with ticketing, security or thermal scanner technology',
  pricingFeatureList3Line8: 'Give confidence to your staff and attendees',
  pricingFeatureList3Line9: 'Build wellbeing',
  priceVat: '* - price does not include VAT',
  vatNotInclude: 'does not include VAT',
  submitEnquiry: 'Submit enquiry',
  contactUs: 'Contact us',
  discountDescriptionText:
    'Education, Non-Profit Organisations and Charities are subject to specialised heavily-discounted pricing. Please contact us to discuss.',
  createFreeAccount: 'Create FREE account',
  calculatePrice: 'Calculate price',
  quoteText: 'To get a quote, contact our sales team today',
  pricingPlanCompare: 'How our plans compare',
  pricingCompareRow1: 'Government and GDPR Compliant',
  pricingCompareRow2: `Dashboard for collecting visitor's contact details`,
  pricingCompareRow3: 'Professional reporting capabilities',
  pricingCompareRow4: 'Employee health status verification',
  pricingCompareRow5: 'Dedicated account manager',
  planType: 'Plan type',

  planLite: 'Visitor Registration Solution',
  planPro: 'Health Verification Solution',
  planEnterprise: 'Workplace Solution',

  meheading: 'The Me Project',
  meParagraph1:
    'The Me Project is a revolutionary platform bringing people together through better, more secure personal and professional connections.',
  meParagraph2:
    "Created to combat a digital landscape where our data is too often compromised,  The Me Project's mission is to put you back in control. It's your digital life on your terms.",
  meParagraph3:
    'What ties our platform together is an algorithmic, scannable, keep-for-life symbol which allows people to share their data in a more person-centered way. We are launching with',
  meParagraphLink: 'tested.me',
  meParagraph4:
    ', an app built to give both businesses and individuals confidence in the workplace and social life.',
  meFooterCopy: '© 2020 Me Project',
  theseEmailsHave: 'These emails have',
  thisEmailHave: 'This email has',
  alreadyBeenInvited: 'already been invited',
  validationErrorFound: 'Validation error found for',
  theseEmails: 'these emails',
  thisEmail: 'this email',
  invalidResponse: 'Invalid response',
  visitorName: 'VISITOR NAME',
  lastTempCheck: 'last temperature check',
  contactNumber: 'contact number',
  contactEmail: 'contact email',
  lastCovid19Test: 'last covid-19 test',
  lastVaccine: 'last vaccine',
  covidVaccine: 'covid vaccine',
  status: 'status',
  checkedIn: 'checked in',
  flightTime: 'flight date',
  checkedOut: 'checked out',
  employeeName: 'EMPLOYEE NAME',
  employeeFailedPassport: 'passport',
  employeeFailedIdCardNumber: 'id card number',
  calculateMonthlyPrice: 'Calculate your monthly price',
  numberOfEmployees: 'Number of employees:',
  monthlyPrice: 'Your monthly price:',
  back: 'Back',
  welcome: 'Welcome',
  qrCodeScanText: 'Scan this code',
  qrCodeDownloadText:
    'Please download the tested.me app(App store and Google Play) before entering the premises.',
  qrCodeScanQrSymbol:
    'Withing the tested.me app, press this button to scan the Me QR symbol to enter the premises.',
  qrCodeScanQrSymbolAgain:
    'When you leave, Please scan the Me QR symbol again to let us know you have left the premises.',
  qrCodeRegisterVisit:
    'Please scan the Me QR symbol and complete the form to register your visit.',
  qrCodeDownloadApp:
    'To download the tested.me app. go to App store or Google Play.',
  nameLabel: 'name',
  companyNameLabel: ' Company name',
  chooseCompanySizeLabel: 'Company size (no. employees)',
  chooseCompanySizePlaceholder: 'Choose company size',
  chooseIndustryPlaceholder: 'Choose industry',
  messageLabel: 'Message',
  messagePlaceholder: 'Please let us know how your requirements are',
  successMessageTitle: 'Message sent successfully!',
  successFormPopupDescriptionIntro:
    'Thank you for your Workplace Solution enquiry.',
  successFormPopupDescriptionText:
    'We have received your enquiry and will be in touch with you directly.',
  locationSavedSuccess: 'Location added successfully',
  locationUpdatedSuccess: 'Location updated successfully',
  companyUpdatedSuccess:
    'Thank you for keeping your company details up to date!',
  addLocationManagerName: 'Manager name',
  addLocationManagerSurname: 'Manager surname',
  addLocationDetails: 'Add location details',
  editLocationDetails: 'Edit location details',
  addLocationLocationName: 'Location name',
  addLocationEmailAddress: 'Email address',
  addLocationPostcode: 'Postcode',
  addLocationAddressLine1: 'Address line 1',
  addLocationAddressLine2: 'Address line 2',
  addLocationCity: 'City',
  addLocationCountry: 'Country',
  addLocationContactNumber: 'Contact number',
  addLocationWorkingHour: 'Working hours',
  addLocationBuildingCapacity: 'Building Capacity',
  addLocationPlaceHolderFirstName: 'Lucy',
  addLocationPlaceHolderLastName: 'Smith',
  addLocationPlaceHolderLocationName: '',
  addLocationPlaceHolderEmailAddress: 'emailaddress@mail.com',
  addLocationPlaceHolderPostcode: '8HG2',
  addLocationPlaceHolderAddressLine1: 'Green Street 23',
  addLocationPlaceHolderAddressLine2: 'Green Street 23',
  addLocationPlaceHolderCity: 'London',
  addLocationPlaceHolderContactNumber: '00 111 222 333',
  addLocationPlaceHolderBuildingCapacity: '1568',
  preSignedUrlError: 'Error in pre signed url.',
  browseText: 'Browse...',
  uploadSuccessMsg: 'File uploaded.',
  avatarAria: 'Avatar',
  inviteCheckStatus: 'Check status',
  employeesDeleteInvitationButton: 'Delete invitation',
  employeesResendInvitationButton: 'Resend invitation',
  employeesResendInvitationResentMsg: 'Invitation resent',
  employeesResendInvitationLoader: 'Sending...',
  billingNoRecordMsg: 'In this place you will see billing history',
  invitationTypeConfirmed: 'Confirmed',
  invitationTypePending: 'Pending',
  invitationTypeFailed: 'Failed',
  pricingEnterpriseContactFormDisabledMsg:
    'Enterprise enquiry has already been sent. We will get back to you with a response very soon.',
  TrackTraceEventYouContacted: 'In the event that you are contacted by:',
  NHSTrackAndTrace: 'Test & Trace.',
  TrackTraceReadMore: 'Read more',
  TrackTraceMaxViewDescription:
    'In the event that you are contacted by: Test & Trace, please email',
  TrackTraceMaxViewDescription2:
    "with your organisation's details and the date in question.",
  TrackTraceMaxViewDescription3:
    'We will then email you a spreadsheet with the required contact details of any visitors in your premises on that day. Thank you.',
  editCompanyDetails: 'Edit company details',
  editLocationCompanyName: 'Location Name',
  editLocationCity: 'City',
  editLocationAddress1: 'Address Line 1',
  editLocationAddress2: 'Address Line 2',
  editLocationPostcode: 'Postcode',
  editLocationCountry: 'Country',
  editLocationSaveChanges: 'Save changes',
  editLocationCancel: 'Cancel',
  currentPlanButtonLabel: 'Current plan',
  downgradeButtonLabel: 'Downgrade',
  upgradeButtonLabel: 'Upgrade',
  locationAddressLabel: 'Location address',
  numberError: 'Allow numbers only',
  remoteWorkText: 'Remote work',
  covidTestText: 'COVID test',
  testResultText: 'Test Result',
  typeText: 'Type',
  testCenterText: 'Test Center',
  thermalScannerText: 'Thermal scanner',
  checkoutBtnText: 'Check out',
  updatedSuccessMessage: 'User has been checked out from the work space.',
  passwordVerificationHeading:
    'Please enter your password to view more details about this employee',
  passwordVerificationPlaceHolderPassword: 'Enter password',
  passwordVerificationEnterPassword: 'Enter password',
  enterText: 'Enter',
  completeRegistrationButtonLabel: 'Complete',
  completeRegistrationHeader: 'Complete registration',
  employeeStatusRedDescription:
    'Individual has shared health data which indicates they should not be allowed into the premises',
  employeeStatusYellowDescription:
    'Individual has not shared enough health data to understand whether they are safe to enter the premises or not',
  employeeStatusGreenDescription:
    'Individual has shared health data to identify them as safe to enter the premises',
  employeeStatusWhiteDescription:
    'The individual has not yet shared the required information',
  employeeNoTestText:
    'The user has not added their COVID test result to their tested.me profile',
  employeeNoTemperatureText:
    'The user has not added their temperature to their tested.me profile',
  closeText: 'Close',
  haveYouGotQuestion: 'Have you got a question?',
  about: 'About',
  aboutBanner:
    'Tested.me is a digital health information management system; reinventing the way we share and use our health data to benefit ourselves and those around us.',
  ourStory: 'Our story',
  aboutContent1: 'Tested.me began with a question:',
  aboutHeading1:
    '”What if we could create a digital solution to help people get back to their work and social lives, safely and responsibly?”',
  whyStarted: 'Why we started?',
  aboutContent2:
    'It was the middle of the Covid-19 pandemic and the thought was inspired by a family member whose business had been affected by the UK lockdown.',
  howStarted: 'How we started?',
  aboutContent3:
    'That’s when we started researching. We quickly learned that there was nothing taking care of people’s health data, ethically and securely. Plus, there was no platform helping to actively build trust when people did return to their work and social lives. We quickly got to work and, within three months, launched our first platform.',
  numbersHeading: 'Tested me in numbers today',
  peopleNumber: '200,000+',
  peopleContent: 'people have used our venue registration software',
  businessNumber: '600+',
  businessContent: 'businesses are currently using tested.me',
  introduceHeading: 'Introducing The Me Project',
  introParagraph1:
    'The Me Project is a revolutionary platform bringing people together through better, more secure personal and professional connections.',
  introParagraph2:
    'Created to combat a digital landscape where our data is too often compromised, The Me Project’s mission is to put you back in control of your health data. It’s your digital life on your terms.',
  introParagraph3:
    'What ties our platform together is an algorithmic, scannable, keep-for-life symbol which allows people to share their data in a more person-centred way. Tested.me is The Me Project’s first launch.',
  ourTeam: 'Our Team',
  testedMePartner:
    'Tested.me operates a global Business Partner Channel. If you are interested in becoming one of our trusted Business Partners, please email',
  businessEmail: 'businesspartners@tested.me',
  greenBannerContent: 'Have you got a question?',
  support: 'Support',
  employeeDeleteConfirmMsg: 'Are you sure you want to remove this employee?',
  removeThem: 'Remove employee',
  noKeepThem: 'No, keep them',
  yesRemoveThem: 'Yes, remove them',
  deleteEmployeeSuccessMessage: 'Employee removed successfully.',
  wellBeingEmployeesDescription:
    'Total number denotes the number of employee who have reported their well-being today',
  chooseWellBeingPlaceholder: 'Well-being: All',
  wellBeingTypeAll: 'All',
  wellBeingTypeGreat: 'Feeling great',
  wellBeingTypeNormal: 'Feeling normal',
  wellBeingTypeNotSure: 'Not too sure',
  wellBeingTypeNotWell: "Don't feel well",
  chooseWorkingRemotelyPlaceholder: 'Remote: All',
  workingRemotelyTypeAll: 'All',
  workingRemotelyTypeAgreedWithEmployee: 'Agreed with employer',
  workingRemotelyTypeDueToIllness: 'Due to illness / symptoms',
  workingRemotelyTypeDueToIsolation: 'Due to isolation guidelines',
  employeeNameTitle: 'EMPLOYEE NAME',
  checkInDateTitle: 'CHECK IN DATE',
  checkInTimeTitle: 'CHECK IN TIME',
  contactNoTitle: 'CONTACT NUMBER',
  emailTitle: 'EMAIL',
  managerNameTitle: 'MANAGER NAME',
  cityTitle: 'CITY',
  locationNameTitle: 'LOCATION NAME',
  newVatFeature: 'New feature!',
  newVatDescription:
    'You can now enter your company’s VAT/GST number, so we can automatically add it to your invoices.',
  vatLabel: 'VAT/GST',
  doThisLater: 'Do it later',
  employeeDetailsRemoveTitle: 'Are you sure you want to remove this employee?',
  employeeDetailsRemoveText: 'They will no longer be able to check in to work.',
  changePermissionsLabel: 'Change permissions',
  removeLabel: 'Remove',
  changePermissionsVisitorsLabel: 'View visitors',
  changePermissionsEmployeeDataLabel: 'View employee data',
  changePermissionsEmployeeEditLabel: 'Add, remove & edit employees',
  changePermissionsBillingLabel: 'Billing settings access',
  changePermissionsMedicalProfessionalLabel: 'Medical data approver',
  selectWorkspaceDescription: 'Choose your workspace',
  continueText: 'Continue',
  invitationModalHeading: 'Invitation status',
  invitationDeliveredTo: 'Invitation delivered to',
  invitationDelivered: 'Invitation delivered',
  invitationEmailReadByUser: 'Email read by user',
  invitationEmailReadByUserTitle:
    'Depends on if the user allows HTML emails in their inbox',
  invitationUserHasApp: 'User has app',
  invitationDisplayedInApp: 'Invitation displayed in app',
  invitationAccepted: 'Invitation Accepted',
  invitationRejected: 'Invitation rejected',
  invitationIncorrectEmail: 'Incorrect email',
  invitationPending: 'Invitation pending',
  invitationRemoveText: 'Remove invitation',
  invitationResendText: 'Resend invitation',
  invitationDaysAgoText: 'days ago',
  searchText: 'Search',
  employeeDetailsAgreedWithEmployer: 'Agreed with employer',
  employeeDetailsPermissionStaticText:
    'View visitors, edit and delete employee',
  employeeDetailsJoinedText: 'Joined: ',
  employeeDetailsCheckInsText: 'Check ins: ',
  employeeDetailsLogsText: 'Logs',
  employeeDetailsLogsFound: 'entries found',
  employeeDetailsLogsTotal: 'total',
  employeeDetailsHealthText: 'Health',
  employeeDetailsSettingsText: 'Settings',
  allLocationsText: 'All',
  entriesText: 'entries',
  employeeDetailsEventText: 'EVENT',
  employeeDetailsDetailsText: 'DETAILS',
  employeeDetailsDateTimeText: 'DATE & TIME',
  employeeDetailsPermissionsText: 'User permissions',
  employeeDetailsAccountText: 'Account',
  employeeDetailsRemoveEmployeeText: 'Remove employee',
  employeeDetailsRemoveConfirmText: 'Are you sure you sure you want to remove ',
  employeeDetailsFromTheCompanyText: ' from the company?',
  employeeDetailsNoText: 'No',
  employeeDetailsYesRemoveText: 'Yes, remove',

  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
  fornightly: 'Fornightly',
  timeError: 'Enter the time in the correct format',
  monthlyOptionDescription:
    'Employee check will be sent out on the first day of each month at 8:00 AM.',
  weeklyOptionDescription:
    'Employee check will be sent out on the current day of each week at 8:00 AM.',
  fornightlyOptionDescription:
    'Employee check will be sent out on the current day of each fornightly at 8:00 AM.',
  employeeCheckNotifyUpdatedSuccessfully: 'Notifications updated successfully!',
  employeeCheckNotifyGotSuccessfully: 'Notifications got successfully!',

  employeeDetailsLogsFilterButton: 'Filter',
  employeeDetailsLogsFilterAddButton: 'Add filters',
  employeeDetailsLogsFilterEvents: 'Events',
  employeeDetailsLogsFilterCheckInOut: 'Check in/out',
  employeeDetailsLogsFilterCheckInOutAll: 'All',
  employeeDetailsLogsFilterCheckInLocal: 'Local check ins',
  employeeDetailsLogsFilterCheckOutLocal: 'Local check outs',
  employeeDetailsLogsFilterCheckups: 'Daily checkups',
  employeeDetailsLogsFilterCheckupsAll: 'All',
  employeeDetailsLogsFilterCheckupsExactTemp: 'Temperature (exact)',
  employeeDetailsLogsFilterCheckupsExactTempValue: 'Value',
  employeeDetailsLogsFilterCheckupsTempRange: 'Temperature range',
  employeeDetailsLogsFilterCheckupsTempRangeFrom: 'From',
  employeeDetailsLogsFilterCheckupsTempRangeTo: 'To',
  employeeDetailsLogsFilterCheckupsFeeling: 'Feeling',
  employeeDetailsLogsFilterHealth: 'Health',
  employeeDetailsLogsFilterActions: 'Employee actions',
  employeeDetailsLogsFilterAccount: 'Account',
  employeeDetailsLogsFilterDateTime: 'Date',
  employeeDetailsLogsFilterDateTimeExactDate: 'Date (exact)',
  employeeDetailsLogsFilterDateTimeExactDateValue: 'Value',
  employeeDetailsLogsFilterDateTimeDateRange: 'Date range',

  employeeDetailsLogsFilterCheckInOutChipLabel: 'Check in/out:',
  employeeDetailsLogsFilterCheckInOutChipAll: 'All',
  employeeDetailsLogsFilterCheckInOutChipCheckIns: 'Local check ins',
  employeeDetailsLogsFilterCheckInOutChipCheckOuts: 'Local check outs',
  employeeDetailsLogsFilterDateChipLabel: 'Date:',
  employeeDetailsLogsFilterDateRangeChipLabel: 'Date range:',
  employeeDetailsLogsFilterTemperatureChipLabel: 'Temperature:',
  employeeDetailsLogsFilterTemperatureRangeChipLabel: 'Temperature range:',
  employeeDetailsLogsFilterFeelingChipLabel: 'Feeling:',
  employeeDetailsLogsFilterFeelingChipAll: 'All',
  employeeDetailsLogsFilterCheckupsChipLabel: 'Checkups:',
  employeeDetailsLogsFilterCheckupsChipAll: 'All',
  employeeDetailsLogsFilterActionsChipLabel: 'Events:',
  employeeDetailsLogsFilterActionsChipAll: 'All',

  changeLabel: 'Change',
  addLabel: 'Add',

  visitorText: 'Visitor',
  visitorDetailsHealthTestText: 'Health test',
  visitorDetailsTemperatureText: 'Temperature / health',
  visitorDetailsTemperatureDescription: '(last 3 measurements)',
  visitorDetailsVaccinesText: 'Vaccines',
  covidTestsText: 'COVID tests',
  temperatureText: 'Temperature',
  wellBeingText: 'Well-being',
  vaccinesText: 'Vaccines',
  verifiedText: 'VERIFIED',
  positiveAntibodyText: 'Positive antibody',
  negativeAntibodyText: 'Negative antibody',
  negativeNABOldText: 'IgG positive and neutralising antibody negative',
  negativeNABNewText: 'IgG positive, NAB negative',
  positiveNABOldText: 'IgG positive and neutralising antibody positive',
  positiveNABNewText: 'IgG positive, NAB positive',
  viewScanText: 'View scan',
  covidText: 'COVID',
  wellBeingDescription:
    'Only the most recent well-being data on a given day is included.',
  temperatureDescription:
    'Only the most recent temperature measurement on a given day is included.',
  wellBeingGreatText: 'Great',
  wellBeingOkText: 'Ok',
  wellBeingNotSureText: 'Not sure',
  wellBeingNotWellText: 'Not well',
  visitorDetailsStatusText: 'Submitted by user.',

  eventsName: 'Event name',
  eventsDate: 'Event date',
  eventsAttendeesCount: 'Attendees',

  eventsAddButton: 'add event',
  eventsAddHeader: 'Add event',
  eventsAddNameLabel: 'Event name',
  eventsAddTypeLabel: 'Event type',
  eventsAddTypePlaceholder: 'Choose event type',
  eventsAddStartDateLabel: 'Start date',
  eventsAddStartTimeLabel: 'Start time',
  eventsAddEndDateLabel: 'End date',
  eventsAddEndTimeLabel: 'End time',
  eventsAddRulesToEntryHeader: 'Rules to entry',
  eventsModalSwitchAnd: 'AND',
  eventsModalSwitchOr: 'OR',
  eventsModalSwitchLabelAnd: 'All active items below will be required.',
  eventsModalSwitchLabelOr: 'Only one of the items below will be required.',
  eventsAddRulesToEntryCovidTestLabel: 'Negative COVID test',
  eventsAddRulesToEntryCovidTestType: 'Test type(s):',
  eventsAddRulesToEntryCovidTestFirstAntigenLabel:
    '1st rapid antigen done max.',
  eventsAddRulesToEntryCovidTestOnDayAntigenLabel: 'On the day antigen test',
  eventsAddRulesToEntryCovidTestRTPCRLabel: 'RT PCR done max.',
  eventsAddRulesToEntryCovidTestBeforeLabel: 'hours before the event',
  // FIXME: This is placeholder copy for on day antigen test
  eventsAddRulesToEntryCovidTestOnDayLabel:
    'please take this test on the day that you are attending the event',
  eventsAddRulesToEntryCovidTestMoreThanZeroError:
    'Value must be greater than 0',
  eventsAddRulesToEntryVaccinationLabel: 'Vaccination',
  eventsOneOfTestTypesNeedsToBeSelected:
    'One of the tests needs to be selected',
  eventsAddSuccess: 'Event added successfully',

  eventAttendeesPreEventStatsTotal: 'Total number of attendees',
  eventAttendeesPreEventStatsApproved: 'Attendees approved for the event',
  eventAttendeesPreEventStatsFlagged: 'Attendees not approved for the event',
  eventAttendeesPreEventStatsNotTested: 'Awaiting data',
  eventDetailsAttendeeName: 'name',
  eventDetailsContactEmail: 'contact email',

  eventAttendeesOngoingCheckedIn: 'Attendees checked in',
  eventAttendeesOngoingNotCheckedIn: 'Attendees not checked in',
  eventAttendeesOngoingRequirementsNotMet: 'Entry requirements not met',
  eventAttendeesOngoingTotal: 'Total number of attendees',

  preEventLabel: 'Pre-event',

  accountSuspendedTitle: 'Account Suspended',
  accountSuspendedTextFirst:
    'We regret to inform you that your account has been suspended.',
  accountSuspendedTextSecond:
    'If you’re not sure why you’re seeing this message, please contact',
  accountSuspendedSupportText: 'our customer support',
  accountSuspendedBackLink: 'Back to login',

  learnMorePlus: 'Learn More +',

  ariaGoToHomePage: 'go to home page',
  ariaInstallAppTopSection: 'install app top section',
  ariaInstallAppBottomSection: 'install app bottom section',
  ariaAppleStore: 'Apple Store',
  ariaGooglePlay: 'Google PLay',
  ariaOurMissionSection: 'our mission section',
  ariaHowItWorksSection: 'how it works section',
  ariaWhatOurCommunitySaysSection: 'what our community says section',
  ariaMeetTestedMeSection: 'meet tested.me section',
  ariaPartnersSection: 'partners section',

  notVerifiedText: 'Not verified',

  paginationPageLabel: 'Page',
  paginationOutOfLabel: 'out of',
  paginationNextPageAriaLabel: 'next page',
  paginationPreviousPageAriaLabel: 'previous page',

  scanQRCodeButtonText: 'Scan QR',
  healthCheckDetailsOrderCard: 'Order',
  healthCheckDetailsPersonalCard: 'Personal',
  healthCheckDetailsInformationCard: 'Information',
  healthCheckDetailsLastUpdate: 'Last Updated:',
  healthCheckOrderTestTypeTool: 'Test type',
  healthCheckOrderTimeTool: 'Order time',
  healthCheckOrderPersonalFullNameTool: 'Full name',
  healthCheckOrderPersonalDocumentsLabel: 'Passport, no. ',
  healthCheckOrderPersonalDocumentsTool: 'Document type and number',
  healthCheckOrderPersonalEmailTool: 'Email address',
  healthCheckFilterBarOrderedText: 'Ordered',
  healthCheckFilterBarConfirmedText: 'Confirmed',
  healthCheckFilterBarWaitingForAntigenResultsText: 'Waiting for Results',
  healthCheckFilterBarTestedText: 'Tested',
  healthCheckTestTypeLabel: 'Test type',
  healthCheckBookedDateLabel: 'Booked for',
  healthCheckEditOrderLabel: 'Edit order',
  healthCheckEditPersonalLabel: 'Edit personal',
  healthCheckDeleteOrderLabel: 'Delete order',
  healthCheckDeleteOrderText:
    'Are you sure you want to remove this order? This action cannot be reversed.',
  healthCheckPreviousStageOrderLabel: 'Previous stage',
  healthCheckPreviousStageOrderText:
    'Are you sure you want to move this order to the previous stage?',
  healthCheckEditOrderNameLabel: 'Name',
  healthCheckEditOrderFirstNameLabel: 'First',
  healthCheckEditOrderLastNameLabel: 'Last',
  healthCheckEditOrderBirthdateLabel: 'Birthdate',
  healthCheckEditOrderDocumentLabel: 'Document',
  healthCheckEditOrderContactLabel: 'Contact',
  healthCheckEditOrderDayLabel: 'Day',
  healthCheckEditOrderMonthLabel: 'Month',
  healthCheckEditOrderYearLabel: 'Year',
  healthCheckEditOrderDocumentTypeLabel: 'Type',
  healthCheckEditOrderDocumentNumberLabel: 'Number',
  healthCheckEditOrderContactEmailLabel: 'Email',
  healthCheckEditOrderTypeLabel: 'Order type',
  healthCheckEditOrderOtherRefNumberLabel: 'Booking ref.',
  healthCheckEditOrderOtherBarcodeNumberLabel: 'Barcode no.',
  healthCheckEditOrderIncorrectDocumentNumberText: 'Incorrect document number',
  healthCheckEditOrderIncorrectBarcodeNumberText: 'Incorrect barcode number',
  healthCheckEditOrderIncorrectInputValueText: 'Incorrect value',
  healthCheckEditOrderOlderThan18Text:
    'You need to be at least 18 years old at test day',
  healthCheckNoRecordsTitleText: 'No records found',
  healthCheckNoRecordsDetailsText: 'No records found matching criteria.',
  healthCheckStartTimerText: 'Start timer',
  healthCheckMarkAsTestedOrderText: 'Mark as tested',
  healthCheckConfirmOrderText: 'Confirm',
  healthCheckResendCertificateText: 'Resend certificate',
  healthCheckDownloadCertificateText: 'Download certificate',
  healthCheckGenerateCertificateText: 'Generate Certificate ',
  healthCheckTestTimerLabelText: 'Timer',
  healthCheckTestPerformedReadyText: 'Ready',
  healthCheckTestPerformedWaitingText: 'Waiting',
  healthCheckTestPerformedExpiredText: 'Expired',

  healthCheckAntigenTestLabelD2: 'Day 2 Antigen',
  healthCheckAntigenTestLabelSelfFTF: 'Fit-To-Fly Antigen (Self Test)',
  healthCheckAntigenTestLabelClinicianFTF:
    'Fit-To-Fly Antigen (Trained Clinician)',
  healthCheckPCRTestLabelD2: 'Day 2 PCR',
  healthCheckPCRTestLabelD5: 'Day 5 PCR',
  healthCheckPCRTestLabelD8: 'Day 8 PCR',
  healthCheckPCRTestLabelSelfFTF: 'Fit-To-Fly PCR (Self Test)',
  healthCheckPCRTestLabelClinicianFTF: 'Fit-To-Fly PCR (Trained Clinician)',

  healthCheckPCRTestLabel: 'PCR',
  healthCheckAntigenTestLabel: 'Antigen',
  healthCheckGeneratePCRCertificateLabel: 'Generate RT PCR Certificate',
  healthCheckGenerateAntigenCertificateLabel: 'Generate Antigen Certificate',
  healthCheckAddResultsText: 'Add results',
  healthCheckAddResultsReportedDateEarlierTakenDateErrorText:
    'Test taken date should be earlier than reported date',
  healthCheckAddResultsCurrentDateEarlierSelectedDateErrorText:
    'Selected date and time should be earlier than current date and time',
  healthCheckConfirmMethodText:
    'Please confirm the method text to be shown on the certificate.',
  healthCheckEditResultsText: 'Edit results',
  healthCheckPreviousStageText: 'Previous stage',
  healthCheckAddResultsDescriptionText: 'Adding results for',
  healthCheckAddResultsAddScanText: 'Add scan',
  healthCheckResultPositiveLabel: 'Positive',
  healthCheckResultNegativeLabel: 'Negative',
  healthCheckResultIndeterminateLabel: 'Indeterminate',
  healthCheckResultMobileUploadButtonLabel: 'Upload scan',
  healthCheckTestCategoryDay2Label: 'Day 2',
  healthCheckTestCategoryFitToFlyLabel: 'Fit to Fly',
  healthCheckTestCategorySelfTestLabel: 'Self Test',
  healthCheckConfirmButtonCompleteNotification: 'Order confirmed successfully!',
  healthCheckSaveOrderSuccessfully: 'Order successfully modified.',
  healthCheckSaveAddResultSuccessfully: 'Results added successfully!',
  healthCheckCouldNotSaveError: 'Couldn’t save data due to an error.',
  healthCheckCouldNotDeleteError: 'Couldn’t delete order due to an error.',
  healthCheckDeleteOrderSuccessfully: 'Order removed successfully.',
  healthCheckTimerStartedNotification: 'Timer started.',
  healthCheckTimerFinishedNotification: 'Timer finished.',
  healthCheckGenerateAndResendCertificateNotification:
    'A message has been sent to your email.',
  healthCheckOrderDetailsError: 'Oops! Something went wrong.',
  healthCheckMenuOrdersOption: 'Orders',
  healthCheckMenuLogoutOption: 'Logout',
  healthCheckMenuRefreshOTPOption: 'Refresh OTP',
  healthCheckSearchAndFilters: 'Search and filters',
  healthCheckTestTypeDropdownBeforeText: 'Type',
  healthCheckMissingResultText: 'Missing result',
  healthCheckAddDateLabel: 'Test taken date',
  healthCheckAddTimeLabel: 'Test taken hour',
  healthCheckReportedDateLabel: 'Reported date',
  healthCheckReportedTimeLabel: 'Reported hour',

  exportCSVButtonText: 'CSV',
  healthCheckRefreshOTPModalLabel: 'Refresh OTP',
  healthCheckRefreshOTPModalDescription: 'Please enter the new OTP below.',
  healthCheckRefreshOTPModalInputPlaceholder: 'OTP',
  healthCheckRefreshOTPSuccessful: 'OTP refreshed successfully.',

  healthCheckResultCertificateHeaderText: 'Certificate',
  healthCheckResultCertificateSubHeadingTextStart:
    'Confirmation this is a genuine Vitacheck certification for Covid-19',
  healthCheckResultCertificateSubHeadingTextEnd: 'Test',
  healthCheckResultCertificateProvidedByText: 'Provided by',
  healthCheckResultCertificateNotFoundText: 'Certificate not found',
  healthCheckResultCertificateNotFoundDescriptionText:
    'Please make sure that the QR code hasn’t been damaged and there’s enough light in the room before trying again.',

  bottomInputLabel: 'Please complete this field.',
};

export default en;
